/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Text, Tooltip, useToast } from '@chakra-ui/react';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useStore from '../../../store';

const Q_PROPOSAL = gql`
	query get($proposalNumber: Float!) {
		getCompanySubmissionsProposalByProposalNumber(proposalNumber: $proposalNumber) {
			id
			subject
			no
			createdAt
			assignTo {
				id
				user {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				createdBy
			}
		}
	}
`;

const ProposalNumberLink = ({ proposalNumber = null }) => {
	const toast = useToast();
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const { push } = useHistory();
	const [loadData, { data }] = useLazyQuery(Q_PROPOSAL);

	useEffect(() => {
		if (proposalNumber) {
			loadData({ variables: { proposalNumber: parseInt(proposalNumber) } });
		}
	}, [proposalNumber]);

	return (
		<>
			{data?.getCompanySubmissionsProposalByProposalNumber && (
				<Tooltip label={t('Click to view')}>
					<Text
						cursor="pointer"
						color="#3498DA"
						fontWeight="bold"
						onMouseDown={() => {
							const userIds = data?.getCompanySubmissionsProposalByProposalNumber?.assignTo?.map((assignTo) => assignTo?.user?.id);
							const canView = userIds?.includes(user?.id) || user?.role === 'admin';
							if (canView) {
								push(`/company-submission-proposal/detail?id=${data?.getCompanySubmissionsProposalByProposalNumber?.id}`);
							} else {
								toast({
									title: t('You are not assigned in the proposal'),
									status: 'warning',
									isClosable: true,
									position: 'bottom',
								});
							}
						}}
					>
						<span>{data?.getCompanySubmissionsProposalByProposalNumber?.no}</span>
						<FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: 12, color: '#3498DA', marginLeft: 4, marginBottom: 1 }} />
					</Text>
				</Tooltip>
			)}
		</>
	);
};

export default ProposalNumberLink;
